/* ---------------------------------------------------------------------------
(c) 2023-2024, HID Global Corporation, part of ASSA ABLOY.
All rights reserved.

This program is an un published copyrighted work which is proprietary
to HID Global Corporation. This computer program includes Confidential,
Proprietary Information and is a Trade Secret of HID Global Corporation.
Any use, disclosure, modification and/or reproduction is prohibited
unless authorized in writing by HID Global Corporation.

WARNING:  Unauthorized reproduction of this program as well as
unauthorized preparation of derivative works based upon the
program or distribution of copies by sale, rental, lease or
lending are violations of federal copyright laws and state trade
secret laws, punishable by civil and criminal penalties.
--------------------------------------------------------------------------- */

declare const window: any;
export class DynamicEnvironment {
  public get config() {
    return window.config;
  }
}

export const serverUrl = new DynamicEnvironment();

export class Base {
  public static readonly REDIRECT_URL = location.origin;
  public static readonly AUTH_URL = '/idp/{tenantId}/authn/';
  public static readonly SSP_URL = '/ssp/';
}

export const deviceEntity = {
  HIDAPPROVE: 'hidapprove',
  DEVICE: 'obtainDevice',
  SEARCH: 'search',
  SETUP: 'setup',
  STATUS: 'status',
  UNLOCK: 'pinUnlock',
  DEVICETYPE: 'type'
};

export const credentialEntity = {
  STATUS: 'status'
};

export const userEntity = {
  USERINFO: 'userInfo',
  CHANGEPASSWORD: 'changePassword',
  APPROVESECURECODE: 'validateOtp',
  SSPCONFIG: 'sspconfig'
};

export const authenticatorEntity = {
  policy: 'policy/authenticator'
};

export const environment = {
  production: false,
  authApi: {
    token: {
      POST: Base.AUTH_URL + 'token'
    },
    login: {
      GET: Base.AUTH_URL + 'login'
    },
    revoke: Base.AUTH_URL + 'revoke',
    userinfo: Base.AUTH_URL + 'userinfo',
    enroll: Base.AUTH_URL + 'enroll'
  },

  sspAPI: {
    device: {
      CREATE: Base.SSP_URL + 'device/{deviceEntity}', // API for POST
      COMMON: Base.SSP_URL + 'device/{deviceEntity}/{id}' // API for GET PUT POST Delete
    },
    authenticator: {
      SEARCH: Base.SSP_URL + 'authenticator/search',
      POLICY: {
        COMMON: Base.SSP_URL + '{authenticatorEntity}/{id}'
      },
      POST: Base.SSP_URL + 'users/Authenticator'
    },
    user: {
      CREATE: Base.SSP_URL + 'users/{userEntity}', // API for POST
      COMMON: Base.SSP_URL + 'users/{userEntity}/{id}' // API for GET PUT
    },
    credential: {
      COMMON: Base.SSP_URL + 'credential/{credentialEntity}/{id}' // API for GET PUT
    },
    par: {
      COMMON: Base.SSP_URL + 'par' // API for POST
    },
    adc: {
      COMMON: Base.SSP_URL + 'ResourceTypes/{id}' // API for GET
    },
    workflow: {
      COMMON: Base.SSP_URL + 'workflow/Self_Service_Portal' //API for GET Workflow
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
